import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Réinitialiser votre mot de passe")
], -1)
const _hoisted_3 = { class: "fv-row mb-10" }
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, " Nouveau mot de passe ", -1)
const _hoisted_6 = { class: "position-relative mb-3" }
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, " Utilisez au moins 10 caractères avec au moins un chiffre, une minuscule, une majuscule et un caractère spécial parmi les suivants : ~ ! @ # $ % ^ & * ( ) _ + { } \" : ; ' [ ] ? , . \\ / = + € - ° § ¿ • ± ¥ Ø ", -1)
const _hoisted_10 = { class: "fv-row mb-10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack mb-2" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0 required" }, "Confirmation du mot de passe")
], -1)
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Réinitialiser ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Veuillez patienter... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form w-100",
      id: "kt_login_signin_form",
      onSubmit: _ctx.onSubmitResetPassword,
      "validation-schema": _ctx.resetPasswordValidator
    }, {
      default: _withCtx(({ meta }) => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: _ctx.toggleVisibility ? 'password' : 'text',
                placeholder: "",
                name: "password",
                autocomplete: "off"
              }, null, 8, ["type"]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ErrorMessage, { name: "password" })
                ])
              ]),
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleVisibility = !_ctx.toggleVisibility)),
                class: "mt-3 text-end link-primary fs-6 fw-bold"
              }, _toDisplayString(_ctx.toggleVisibility
                  ? "Voir le mot de passe"
                  : "Cacher le mot de passe"), 1)
            ])
          ]),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: _ctx.toggleVisibility ? 'password' : 'text',
            name: "password_confirm",
            autocomplete: "off"
          }, null, 8, ["type"]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_ErrorMessage, { name: "password_confirm" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            type: "submit",
            ref: "submitButton",
            id: "kt_sign_in_submit",
            class: "btn btn-lg btn-primary w-100 mb-5",
            disabled: !(meta.valid && meta.dirty)
          }, _hoisted_18, 8, _hoisted_15)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}